import React, { useState, useEffect } from "react";

import avatar from "../../../../assets/img/avatars/simpleAvatar.jpg";
import banner from "../../../../assets/img/profile/banner.png";
import Card from "../../../../components/card";
import { upperCaseFirstLetter } from "../../../../utils/formatStringUtils";

const Banner = ({
  projectCount,
  hourSum,
  projectTimeSheetApproved,
  projectTimeSheetInProgress,
  projectTimeSheetInAnalysis,
}) => {
  const [profileName, setProfileName] = useState<string>("");
  const [profileEmail, setProfileEmail] = useState<string>("");

  useEffect(() => {
    const userName = localStorage.getItem("userName");
    const userEmail = localStorage.getItem("userEmail");

    setProfileName(upperCaseFirstLetter(userName));
    setProfileEmail(userEmail);
  }, [profileName, profileEmail]);

  const stats: { label: string; value: React.ReactNode; accent?: string }[] = [
    { label: "Projetos", value: projectCount },
    { label: "Total de horas", value: hourSum },
    { label: "Em andamento", value: projectTimeSheetInProgress, accent: "blue" },
    { label: "Em análise", value: projectTimeSheetInAnalysis, accent: "amber" },
    { label: "Aprovados", value: projectTimeSheetApproved, accent: "emerald" },
  ];

  const accentText: Record<string, string> = {
    blue: "text-dv-blue-600 dark:text-dv-cyan-300",
    amber: "text-amber-600 dark:text-amber-400",
    emerald: "text-emerald-600 dark:text-emerald-400",
  };

  return (
    <Card extra={"items-center w-full h-full p-4"}>
      {/* Background and profile */}
      <div
        className="relative mt-1 flex h-32 w-full justify-center rounded-2xl bg-cover bg-center"
        style={{ backgroundImage: `url(${banner})` }}
      >
        <div className="absolute -bottom-12 flex h-[88px] w-[88px] items-center justify-center rounded-full border-[4px] border-white bg-white shadow-lg dark:!border-navy-700">
          <img
            className="h-full w-full rounded-full object-cover"
            src={avatar}
            alt={profileName ? `Foto de ${profileName}` : "Foto do perfil"}
          />
        </div>
      </div>

      {/* Name and position */}
      <div className="mt-16 flex flex-col items-center text-center">
        <h4 className="text-xl font-bold text-navy-700 dark:text-white">
          {profileName}
        </h4>
        <p className="mt-0.5 text-sm font-medium text-gray-700 dark:text-gray-300">
          {profileEmail}
        </p>
      </div>

      {/* Stats */}
      <div className="mb-3 mt-6 grid w-full grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-5">
        {stats.map((stat) => (
          <div
            key={stat.label}
            className="flex flex-col items-center justify-center rounded-2xl border border-gray-100 bg-gray-50 px-3 py-4 text-center transition-all duration-200 hover:-translate-y-0.5 hover:shadow-dv-md dark:border-white/10 dark:!bg-navy-900"
          >
            <p
              className={`font-display text-2xl font-bold tabular-nums tracking-tight ${
                stat.accent
                  ? accentText[stat.accent]
                  : "text-navy-700 dark:text-white"
              }`}
            >
              {stat.value}
            </p>
            <p className="mt-1 text-xs font-medium text-gray-700 dark:text-gray-300">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default Banner;
